import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDelonghiComponent } from './simple-icons-delonghi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDelonghiComponent ],
    exports:      [ SimpleIconsDelonghiComponent ],
    bootstrap:    []
})
export class SimpleIconsDelonghiModule {}
